/*
 * ============================================================
 * ALPHABET-BUILDER — picker logic + locked-bundle add to cart
 * ------------------------------------------------------------
 * Paired with: snippets/alphabet-bundle-picker.liquid
 *
 * Two modes, chosen by the container's data-mode attribute:
 *  - letters (default, alphabet kits): 3 all-different dropdowns;
 *    out-of-stock letters (data-stock="out") always disabled; add
 *    posts Supplies Pack + 3 letter variants.
 *  - cards (trick-or-treat bag kit): tap ONE photo card (bag color);
 *    add posts Supplies Pack + the chosen bag variant.
 * Both tag lines with a shared hidden `_ab_bundle` id so the cart
 * groups/locks them (see cart files), then open the cart drawer
 * (falling back to /cart).
 *
 * Search tag: ALPHABET-BUILDER
 * ============================================================
 */
(function () {
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function openCart(parsed) {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (parsed && parsed.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(parsed);
          if (typeof drawer.open === 'function') drawer.open();
          return;
        }
        if (typeof drawer.open === 'function') { drawer.open(); return; }
      }
    } catch (e) { /* fall through to full cart page */ }
    window.location.href = root() + 'cart';
  }

  function init(container) {
    if (!container || container.dataset.abInit === '1') return;
    container.dataset.abInit = '1';

    // TRICK-OR-TREAT (cards) mode — one photo card + the supplies pack
    if (container.getAttribute('data-mode') === 'cards') { initCards(container); return; }

    var selects = Array.prototype.slice.call(container.querySelectorAll('.ab-select'));
    var addBtn = container.querySelector('#ab-add');
    var hint = container.querySelector('#ab-cta-hint');
    var chipsWrap = container.querySelector('#ab-chips');
    if (!selects.length || !addBtn) return;

    var suppliesId = container.getAttribute('data-supplies-id');
    var kitLabel = container.getAttribute('data-kit-label') || 'Kit';
    var count = parseInt(container.getAttribute('data-letters-count') || '3', 10);
    var soldOut = container.getAttribute('data-supplies-soldout') === 'true';
    var defaultLabel = 'Choose ' + count + ' letters to continue';

    function values() {
      return selects.map(function (s) { return s.value; });
    }
    function letters() {
      return selects.map(function (s) {
        var o = s.options[s.selectedIndex];
        return o ? (o.getAttribute('data-letter') || '') : '';
      });
    }

    function refresh() {
      var vals = values();

      // All-different: disable a letter in OTHER dropdowns if it's chosen
      // elsewhere. Never touch options flagged out of stock.
      selects.forEach(function (sel, i) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          if (!opt.value) return;
          if (opt.getAttribute('data-stock') === 'out') { opt.disabled = true; return; }
          opt.disabled = vals.some(function (v, j) { return j !== i && v && v === opt.value; });
        });
        sel.classList.toggle('ab-select--chosen', !!sel.value);
      });

      // Update the letter chips
      if (chipsWrap) {
        chipsWrap.innerHTML = '';
        vals.forEach(function (v, i) {
          var chip = document.createElement('span');
          var letter = letters()[i];
          chip.className = 'ab-chip' + (v ? '' : ' ab-chip--empty');
          chip.textContent = v ? letter : '?';
          chipsWrap.appendChild(chip);
        });
      }

      // Validate
      var filled = vals.filter(Boolean);
      var allChosen = filled.length === count;
      var allDifferent = (new Set(filled)).size === filled.length;
      var ready = allChosen && allDifferent && !soldOut;

      addBtn.disabled = !ready;
      if (ready) {
        addBtn.textContent = 'Add to cart';
        hint.textContent = '';
      } else if (allChosen && !allDifferent) {
        addBtn.textContent = 'Letters must all be different';
        hint.textContent = '';
      } else {
        addBtn.textContent = defaultLabel;
        hint.textContent = allChosen ? '' : (count - filled.length) + ' more to choose';
      }
    }

    function add() {
      if (addBtn.disabled) return;
      var letterIds = values();
      var letterLabels = letters();
      var bundleId = 'ab-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);

      var items = [{
        id: Number(suppliesId),
        quantity: 1,
        properties: {
          _ab_bundle: bundleId,
          _ab_role: 'kit',
          _ab_kit: kitLabel,
          Letters: letterLabels.join(' · ')
        }
      }];
      letterIds.forEach(function (id, idx) {
        items.push({
          id: Number(id),
          quantity: 1,
          properties: { _ab_bundle: bundleId, _ab_role: 'letter', _ab_pos: String(idx + 1) }
        });
      });

      var prev = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e; });
          return res.json();
        })
        .then(function (parsed) {
          addBtn.textContent = 'Added ✓';
          openCart(parsed);
          // reset the button shortly after, in case the drawer stays on-page
          setTimeout(function () { addBtn.textContent = prev; refresh(); }, 1500);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = prev;
          alert((err && (err.description || err.message)) || 'Sorry, something went wrong adding your kit. Please try again.');
        });
    }

    selects.forEach(function (s) { s.addEventListener('change', refresh); });
    addBtn.addEventListener('click', add);
    refresh();
  }

  function initCards(container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('.ab-card'));
    var addBtn = container.querySelector('#ab-add');
    if (!cards.length || !addBtn) return;

    var suppliesId = container.getAttribute('data-supplies-id');
    var kitLabel = container.getAttribute('data-kit-label') || 'Kit';
    var soldOut = container.getAttribute('data-supplies-soldout') === 'true';
    var readyLabel = container.getAttribute('data-cta-ready-label') || 'Add to cart';
    var defaultLabel = 'Choose your bag color to continue';
    var selected = null;

    function refresh() {
      cards.forEach(function (c) { c.classList.toggle('ab-card--selected', c === selected); });
      var ready = !!selected && !soldOut;
      addBtn.disabled = !ready;
      addBtn.textContent = soldOut ? 'Currently out of stock' : (ready ? readyLabel : defaultLabel);
    }

    function add() {
      if (addBtn.disabled || !selected) return;
      var bundleId = 'ab-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      var color = selected.getAttribute('data-color') || '';
      var items = [
        {
          id: Number(suppliesId),
          quantity: 1,
          // 'Bag' (no underscore) is visible: shows on the cart kit line and at checkout
          properties: { _ab_bundle: bundleId, _ab_role: 'kit', _ab_kit: kitLabel, Bag: color }
        },
        {
          id: Number(selected.getAttribute('data-variant-id')),
          quantity: 1,
          // 'letter' is the hidden-component role the cart code already collapses
          properties: { _ab_bundle: bundleId, _ab_role: 'letter' }
        }
      ];

      var prev = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e; });
          return res.json();
        })
        .then(function (parsed) {
          addBtn.textContent = 'Added ✓';
          openCart(parsed);
          setTimeout(function () { addBtn.textContent = prev; refresh(); }, 1500);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = prev;
          alert((err && (err.description || err.message)) || 'Sorry, something went wrong adding your kit. Please try again.');
        });
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.disabled || c.classList.contains('ab-card--oos')) return;
        selected = c;
        refresh();
      });
    });
    addBtn.addEventListener('click', add);
    refresh();
  }

  function boot() {
    var el = document.getElementById('ab-builder');
    if (el) init(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();
